import React from "react";
import {
  Accordion,
  ContentWithImage,
  Headline,
  LinkPrimary,
  List,
  SectionContent,
  Text,
} from "../../../../components";
import { ReactComponent as IlustracaoSaibaMais } from "../../../../assets/images/residencial/ilustracao-mulher-com-duvidas.svg";
import { links } from "../../../../config";
import { OnlyDesktopHeadline } from "./SaibaMais.Style";

const faqList = [
  {
    title: "Como acionar o meu seguro?",
    body: (
      <>
        <Text textSize="sm">
          Se ocorrer algum dano no seu imóvel ou se você precisar de algum
          serviço gratuito, ligue para a nossa central Assistência Dia & Noite e
          Sinistro pelo número{" "}
          <LinkPrimary href="tel:0800 274 1000" label="0800 274 1000" />.
        </Text>
        <Text textSize="sm">
          Forneça os dados solicitados, como nome e CPF do titular do seguro, e
          siga as instruções da nossa equipe.
        </Text>
        <Text textSize="sm">
          Se tiver dúvidas sobre o que o seguro cobre, baixe nossa{" "}
          <LinkPrimary
            target="_blank"
            label="cartilha"
            href={links.residencial.cartilhaSeguro}
          />
          .
        </Text>
      </>
    ),
  },
  {
    title: "O que é a franquia do Seguro Residencial?",
    body: (
      <>
        <Text textSize="sm">
          A franquia é a participação do segurado quando ocorre um sinistro, ou
          seja, quando o cliente precisa acionar o seguro para cobrir um
          incidente que ocorreu em sua casa. Não são todas as coberturas que
          exigem a franquia.
        </Text>
        <Text textSize="sm">
          Exemplo: se os seus equipamentos elétricos forem danificados por uma
          queda de tensão e o reparo custar R$ 2.000,00 e a franquia for de 10%,
          você paga apenas R$ 200,00 e a seguradora paga os R$ 1.800,00
          restantes.
        </Text>
      </>
    ),
  },
  {
    title: "Confira os serviços que você faz on-line",
    body: (
      <>
        <List
          styleType="disc"
          listItems={[
            <> Visualiza seus dados;</>,
            <> Acessa os dados da apólice e as suas coberturas;</>,
            <> Emite boletos para pagamento;</>,
            <> Emite 2ª via da sua apólice (contrato);</>,
            <> Aciona suas coberturas (abre um sinistro).</>,
          ]}
          forEach={(item) => <Text textSize="sm">{item}</Text>}
        />

        <Text textSize="sm">
          Acesse agora a sua{" "}
          <LinkPrimary
            target="_blank"
            label="área do cliente"
            href={links.residencial.areaLogada}
          />
          .
        </Text>
      </>
    ),
  },
  {
    title: "O que são coberturas e assistências?",
    body: (
      <>
        <Text textSize="sm">
          <strong>Cobertura:</strong> é o evento que resulta em prejuízos no seu
          imóvel e que está previsto no seu seguro. Elas podem ser básicas e
          adicionais, com valores máximo e mínimo de indenização. Você decide o
          valor das indenizações e as coberturas que irão cuidar da sua casa. A
          boa notícia é que, a partir do primeiro pagamento, você já estará
          coberto pelo seguro.
        </Text>
        <Text textSize="sm">
          Por exemplo, se um ladrão entrar em sua residência e levar sua
          televisão, caso tenha o seguro, você receberá a indenização do valor
          que contratou para repor o item.
        </Text>
        <Text textSize="sm">
          <strong>Assistências:</strong> são serviços que oferecemos
          gratuitamente e realizados por profissionais especializados 24h por
          dia.
        </Text>
        <Text textSize="sm">
          Por exemplo, se você chega em casa e percebe que perdeu as chaves, o
          que fazer? Com o Seguro Residencial, você pode solicitar um chaveiro a
          qualquer hora para resolver seu problema.Conheça todas as
          assistências.
        </Text>
        <Text textSize="sm">
          <LinkPrimary
            label="Veja aqui todas as coberturas e assistências"
            href="/paravoce/residencial/coberturas-e-assistencias"
          />
          .
        </Text>
      </>
    ),
  },
  {
    title: `Entenda como são as comissões de venda e
    as participações societárias dos 
    intermediários para o Seguro Residencial`,
    body: (
      <>
        <Text textSize="sm">
          Nos termos da Resolução CNSP nº 382/2020, a Caixa Seguradora S.A.
          informa que a CAIXA, por meio de sua subsidiária integral Caixa
          Seguridade Participações S.A., detém participação societária direta
          sobre a Caixa Seguros Holding S.A., no percentual de 48,21% e,
          indireta sobre a Wiz Soluções e Corretagem de Seguros S.A., no
          percentual de 12,05%.
        </Text>
        <Text textSize="sm">
          Informamos ainda que a Caixa Seguros Holding S.A. detém participação
          societária direta sobre a Wiz Soluções e Corretagem de Seguros S.A.,
          com percentual de 25%. A Caixa Seguros Holding S.A. remunera seus
          intermediários em até 35,89% pela comercialização do seu Seguro
          Residencial, de acordo com o canal de venda.
        </Text>
      </>
    ),
  },
];

const SaibaMais = () => {
  return (
    <SectionContent>
      <ContentWithImage
        imgColumnSize={6}
        image={<IlustracaoSaibaMais />}
        hideMobile
      >
        <OnlyDesktopHeadline as={Headline} styleAs="4" nivel="2">
          Saiba mais sobre o seu seguro
        </OnlyDesktopHeadline>
        <Accordion listItems={faqList} />
      </ContentWithImage>
    </SectionContent>
  );
};

SaibaMais.propTypes = {};

export default SaibaMais;
